import { Handle, Position } from '@xyflow/react';
import { type SimpleNodeData } from '../../../types/node-data';

export const StartNode = ({ data }: { data: SimpleNodeData }) => {
  return (
    <div
      className='px-4 py-2 rounded-full font-medium min-w-[120px] text-center'
      style={{ backgroundColor: 'rgb(82, 82, 82)', color: 'rgb(255, 255, 255)' }}
    >
      {data.label}
      <Handle type='source' position={Position.Right} />
    </div>
  );
};
